import { getEnv } from './getEnv';

export const analyticsEnabledByEnv = () => getEnv('NODE_ENV') === 'production';
